import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OffertHero } from "@/components/sections/OffertHero";
import { RelatedLinks } from "@/components/RelatedLinks";
import { IMAGES } from "@/lib/images";

const productEnum = z.enum(["Solfilm", "Säkerhetsfilm", "Dekorfilm", "Övrigt"]);

export const Route = createFileRoute("/offert")({
  validateSearch: (search) =>
    z.object({ produkt: productEnum.optional() }).parse(search),
  head: () => ({
    meta: [
      { title: "Begär offert på fönsterfilm — gratis och utan förpliktelser | BBN Nordic" },
      { name: "description", content: "Fyll i formuläret för en kostnadsfri offert — solfilm, säkerhetsfilm och dekorfilm i Skåne. Vi hör av oss så snart vi kan." },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: "Begär offert på fönsterfilm" },
      { property: "og:description", content: "Kostnadsfri offert — solfilm, säkerhetsfilm och dekorfilm." },
      { property: "og:url", content: "https://bbnnordic.se/offert" },
      { property: "og:image", content: IMAGES.hero },
    ],
    links: [{ rel: "canonical", href: "https://bbnnordic.se/offert" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: "Begär offert — BBN Nordic",
          url: "/offert",
          description: "Kostnadsfri offert på solfilm, säkerhetsfilm och dekorfilm i Skåne och Göteborg.",
          mainEntity: {
            "@type": "Service",
            name: "Offert på fönsterfilm",
            provider: { "@type": "LocalBusiness", name: "BBN Nordic AB", telephone: "+46771502502" },
            areaServed: [
              { "@type": "AdministrativeArea", name: "Skåne" },
              { "@type": "City", name: "Göteborg" },
            ],
          },
        }),
      },
    ],
  }),
  component: OffertPage,
});

function OffertPage() {
  const { produkt } = Route.useSearch();
  return (
    <>
      <OffertHero defaultProduct={produkt} />
      <RelatedLinks
        items={[
          { to: "/solfilm-foretag", label: "Solfilm", desc: "Reducera värme och bländning." },
          { to: "/sakerhetsfilm", label: "Säkerhetsfilm", desc: "Skydd mot inbrott och splitter." },
          { to: "/dekorfilm", label: "Dekorfilm", desc: "Avskärmning och profilering." },
        ]}
      />
    </>
  );
}
